export default {
  en: {
    'pages.filing.online-spreadsheet.save': 'Save & Exit',
    'pages.filing.online-spreadsheet.title': 'Online spreadsheet tool',
  },
};
